var urlmodal = (function () {
    "use strict";
    if ($('.urlmodal').length > 0) {
        $('.urlmodal').click(function (e) {
            e.preventDefault();
            var $this = $(this);
            var heading = "Varsågod, här är din länk.";
            var intro = "Spara länken nedan och klistra in där du vill använda den."

            var url = $this.attr("href");
            if (SETTINGS.cid) {
                url = (url + "?customerId=" + SETTINGS.cid);
            }
            openModal();
            $('.modal').append("<h2>" + heading + "</h2>");
            $('.modal').append("<p>" + intro + "</p>");
            $('.modal').append("<p><textarea>" + url + "</textarea></p>");
            $('.modal textarea').select();
        });
    }

    function openModal(e) {

        var body = $('body'),
        modal = $('.modal'),
        overlay = $('.overlay'),
        closeBtn = $('<button class="close">&times;</button>'),
        modalData;

        var top, source, template, html;
        modalData = $(this).data();
        modal.append(closeBtn);
        overlay.fadeIn(40);

        top = $(window).height() / 2 - modal.height() / 2 - 100;
        modal.css({ top: top }).fadeIn(40);
    }

})();